import React, { useState, useEffect } from 'react';
import { Box, Typography, Collapse, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ListAltIcon from '@mui/icons-material/ListAlt';

const DetailsSection = ({ missionData, setMissionData, setIsDirty, handleFieldChange }) => {
    const [isDetailsExpanded, setDetailsExpanded] = useState(true);

    useEffect(() => {
        setDetailsExpanded(!missionData?.completedAt);
    }, [missionData]);

    const sectionStyles = {
        backgroundColor: '#ffffff', // White background
        border: '1px solid #dcdcdc', // Light gray border
        borderRadius: '8px', // Rounded corners
        padding: '16px', // Internal padding
        marginBottom: '16px', // Space between sections
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', // Subtle shadow
    };

    return (
        <Box sx={sectionStyles}>
            {/* Section Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginBottom: isDetailsExpanded ? '16px' : '0px',
                }}
                onClick={() => setDetailsExpanded(!isDetailsExpanded)}
            >
                <ListAltIcon sx={{ color: '#42a5f5', marginRight: '8px' }} />
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Details
                </Typography>
                {isDetailsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            {/* Expandable Content */}
            <Collapse in={isDetailsExpanded}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
                    {/* Objectives Input */}
                    <TextField
                        id="objectives"
                        name="objectives"
                        label="Objectives"
                        type="text"
                        value={missionData?.objectives || ''}
                        onChange={handleFieldChange}
                        fullWidth
                        slotProps={{ input: { maxLength: 255 } }}
                        helperText={
                            missionData?.objectives
                                ? `${missionData.objectives?.length}/255 characters used. Clearly define the main goals of this mission (e.g., survey, inspection, photography).`
                                : 'Clearly define the main goals of this mission (e.g., survey, inspection, photography).'
                        }
                    />

                    {/* Location Description Input */}
                    <TextField
                        id="location-desc"
                        name="locationDesc"
                        label="Location Description"
                        type="text"
                        value={missionData?.locationDesc || ''}
                        onChange={handleFieldChange}
                        fullWidth
                        slotProps={{ input: { maxLength: 255 } }}
                        helperText={
                            missionData?.locationDesc
                                ? `${missionData.locationDesc?.length}/255 characters used. Provide details about the location, such as landmarks or specific areas to cover.`
                                : 'Provide details about the location, such as landmarks or specific areas to cover.'
                        }
                    />

                    {/* Insurance Info Input */}
                    <TextField
                        id="insurance-info"
                        name="insuranceInfo"
                        label="Insurance Info"
                        type="text"
                        value={missionData?.insuranceInfo || ''}
                        onChange={handleFieldChange}
                        fullWidth
                        slotProps={{ input: { maxLength: 255 } }}
                        helperText={
                            missionData?.insuranceInfo
                                ? `${missionData.insuranceInfo?.length}/255 characters used. Include insurance details applicable to this mission, such as policy numbers or coverage notes.`
                                : 'Include insurance details applicable to this mission, such as policy numbers or coverage notes.'
                        }
                    />
                </Box>
            </Collapse>
        </Box>
    );
};

export default DetailsSection;